<div class="tag-detail">
  <div class="name">
    <label class="field-label">{{tokens.tagName | translate}}</label>
    <ask-input *ngIf="!loading; else inputSkeleton" [formControl]="tagNameForm"
               [placeholder]="tokens.tagName | translate" [autoFocus]="true" data-testid="tag-name"/>
    <small *ngIf="errors.name" class="field-error" data-testid="name-error">{{errors.name | translate}}</small>
  </div>

  <label class="field-label">{{tokens.color | translate}}</label>
  <div *ngIf="!loading; else colorSkeleton" class="colors" data-testid="tag-color-selector">
    <div (click)="selectedColor(color)" *ngFor="let color of colors" [style.background]="color" class="color-circle"
         data-testid="tag-color">
      <span *ngIf="color === tag.color" class="checked material-icons" data-testid="checked">check</span>
    </div>
  </div>
  <small *ngIf="errors.color" class="field-error">{{errors.color | translate}}</small>
</div>

<ng-template #inputSkeleton>
  <div class="input-skeleton">
    <ask-skeleton [barsHeight]="24" [radius]="10" style="height: 24px;"/>
  </div>
</ng-template>
<ng-template #colorSkeleton>
  <div class="color-skeleton">
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
    <ask-skeleton [barsHeight]="40" appearance="circle" style="height: 40px;"/>
  </div>
</ng-template>
